// UI strings for the alternating weeks (emphasis/; engine pedagogy/emphasis.ts, docs/PEDAGOGY.md
// §5.6): the week's name on the week hub, the door on Tänään after the day's cards, and the two
// ~5-minute offers — a Kuuntele round (a listening week), shadowing + a Puhu take (a pronunciation
// week). Style: docs/FINNISH-STYLE.md (sinä-muoto, no jargon, no intro text).
import { defineArea } from '../area';

export const emphasisFi = {
  /** The week's name by its emphasised strategy (the week hub's line, the door's second line). */
  week: { listening: 'Kuunteluviikko', pronunciation: 'Ääntämisviikko', forms: 'Taivutusviikko', writing: 'Kirjoitusviikko' },
  /** The same, lowercase, in the door's second line ("kuunteluviikko · noin 5 min"). */
  weekLower: { listening: 'kuunteluviikko', pronunciation: 'ääntämisviikko', forms: 'taivutusviikko', writing: 'kirjoitusviikko' },
  /** The offer's name (door, page title, the hub line's link). */
  offer: { 'emphasis-listen': 'Kuuntelukierros', 'emphasis-shadow': 'Varjosta ja äänitä' } as Record<string, string>,
  minutes: (n: number) => `noin ${n} min`,
  /** The offer is done today (the hub line). */
  doneToday: 'tehty tänään',
  listen: {
    start: (n: number) => `Aloita (${n} tehtävää)`,
    loading: 'Ladataan repliikkejä…',
    none: 'Avoinna olevien viikkojen repliikeistä ei ole vielä äänitteitä.',
    browse: 'Sarjan repliikit',
  },
  shadow: {
    progress: (i: number, n: number) => `Repliikki ${i}/${n}`,
    how: 'Kuuntele Petersonia ja sano perässä samaan tahtiin. Äänitä sitten ja vertaa.',
    next: 'Seuraava',
    /** The Puhu take after the lines. */
    word: 'Puhu: viikon sana',
    wordHow: 'Sano sana ääneen ja äänitä se.',
    finish: 'Valmis',
    none: 'Avoinna olevilla viikoilla ei ole vielä Petersonin äänittämiä repliikkejä.',
  },
  /** After the round (both offers). */
  done: 'Päivän kierros on tehty.',
  back: 'Takaisin Tänään-sivulle',
};

export const emphasisEn: typeof emphasisFi = {
  week: { listening: 'Listening week', pronunciation: 'Pronunciation week', forms: 'Forms week', writing: 'Writing week' },
  weekLower: { listening: 'listening week', pronunciation: 'pronunciation week', forms: 'forms week', writing: 'writing week' },
  offer: { 'emphasis-listen': 'Listening round', 'emphasis-shadow': 'Shadow and record' },
  minutes: (n: number) => `about ${n} min`,
  doneToday: 'done today',
  listen: {
    start: (n: number) => `Start (${n} items)`,
    loading: 'Loading the lines…',
    none: 'The lines of the open weeks have no recording yet.',
    browse: 'Show lines',
  },
  shadow: {
    progress: (i: number, n: number) => `Line ${i}/${n}`,
    how: 'Listen to Peterson and say it after him, in step with him. Then record and compare.',
    next: 'Next',
    word: 'Speak: the week’s word',
    wordHow: 'Say the word aloud and record it.',
    finish: 'Done',
    none: 'The open weeks have no lines Peterson recorded yet.',
  },
  done: 'Today’s round is done.',
  back: 'Back to Today',
};

export const area = defineArea('emphasis', emphasisFi, emphasisEn);

declare module '../area' {
  interface AreaMessages extends Record<typeof area.key, typeof emphasisFi> {}
}
